import React from "react";
import { $host } from "../../../../http";
import InputFileUpload from "./InputFileUpload";
import ButtonBaseOutline from "../buttons/ButtonBaseOutline";

const StreamFilesUpload = ({ streamInfo, onFilesChanged, webinarId }) => {

    const handleFileUpload = async (e, type) => {
        if (!e.target.files[0]) return;

        const fData = new FormData()
        fData.append(type, e.target.files[0])

        try {
            await $host.post(`/api/teachers/webinar/update/${webinarId}`, fData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })

            onFilesChanged()
        } catch (err) {
            console.error(err)
        }
    }

    return (<div className="flex gap-2 items-center">
        {/*// Note: временно закомментирован*/}
        {/*<InputFileUpload file={streamInfo?.video_preview}  fileInputName="Превью" onFilesChanged={(e) => handleFileUpload(e, 'video_preview')} >*/}
        {/*    <ButtonBaseOutline borderStyle="dashed">Загрузить превью</ButtonBaseOutline>*/}
        {/*</InputFileUpload>*/}

        <InputFileUpload fileInputName="Конспект" file={streamInfo.manual_pdf} onFilesChanged={(e) => handleFileUpload(e, 'manual_pdf')}>
            <ButtonBaseOutline borderStyle="dashed">Загрузить конспект</ButtonBaseOutline>
        </InputFileUpload>

        <InputFileUpload fileInputName="Скрипт" file={streamInfo.script_pdf} onFilesChanged={(e) => handleFileUpload(e, 'script_pdf')}>
            <ButtonBaseOutline borderStyle="dashed">Загрузить скрипт</ButtonBaseOutline>
        </InputFileUpload>
    </div>)
}

export default StreamFilesUpload 